/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F1_AInputs */

const en_mk_sec_pg_f1_a = /** @type {(inputs: Mk_Sec_Pg_F1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Workspace content is sent to the model provider only as context while an agent works, and we do not use it for any training.`)
};

const id_mk_sec_pg_f1_a = /** @type {(inputs: Mk_Sec_Pg_F1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Isi workspace dikirim ke penyedia model hanya sebagai konteks selama agen bekerja, dan kami tidak memakainya untuk pelatihan apa pun.`)
};

/**
* | output |
* | --- |
* | "No. Workspace content is sent to the model provider only as context while an agent works, and we do not use it for any training." |
*
* @param {Mk_Sec_Pg_F1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f1_a = /** @type {((inputs?: Mk_Sec_Pg_F1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f1_a(inputs)
	return en_mk_sec_pg_f1_a(inputs)
});